import { Box, useMediaQuery, useTheme } from '@mui/material';
import React, { useEffect, useMemo, useState } from 'react';
import { isMobile } from 'react-device-detect';
import { useDispatch, useSelector } from 'react-redux';
import Buttons from '../buttons/buttons';
import './style.css';

import Pannellum from './pannellum';
import { carHotSpotCardStatusSet } from '../../store/interior-slice';
import {
  activeVideoSet,
  carHotSpotCardOpenToggled,
  carHotSpotEnableSet,
  getCarHotSpotEnable,
  getPushStartVideoUrl,
} from '../../store/car-slice';

import { pitchSet, yawSet } from '../../store/interior-slice';

import { getInteriorStatus, showVideoToggled } from '../../store/car-slice';

import { getBackSeatUrl, getCenterConsoleUrl } from '../../store/car-slice';

import { useWindowSize } from '../../hooks/use-window-size';
import { HotspotButton } from '../../components';

function Interior360() {
  // Selectors
  const carHotSpotEnable = useSelector(getCarHotSpotEnable);
  const pushStartVideoUrl = useSelector(getPushStartVideoUrl);
  const centerConsoleUrl = useSelector(getCenterConsoleUrl);
  const backSeatUrl = useSelector(getBackSeatUrl);
  const interiorStatus = useSelector(getInteriorStatus);

  // const pitch = useSelector(getPitch);
  // const yaw = useSelector(getYaw);
  const isPortrait = useMediaQuery('(orientation: portrait)');
  const theme = useTheme();

  const dispatch = useDispatch();
  const { width, height } = useWindowSize();
  const [load, setLoad] = useState(false);

  const interiorImage = useMemo(() => {
    if (interiorStatus === 'center-console') {
      return centerConsoleUrl;
    }

    if (interiorStatus === 'back-seat') {
      return backSeatUrl;
    }
  }, [interiorStatus, centerConsoleUrl, backSeatUrl]);

  const hotspot = (hotSpotDiv) => {
    if (!pushStartVideoUrl) return;
    const imageDiv = document.createElement('img');
    imageDiv.setAttribute('id', 'test1');
    imageDiv.classList.add('pirelly-custom-tooltip');
    imageDiv.setAttribute('src', '/icons.png');
    hotSpotDiv.appendChild(imageDiv);
  };

  const hotspot1 = (hotSpotDiv) => {
    return;
    const imageDiv = document.createElement('img');
    imageDiv.setAttribute('id', 'test2');
    imageDiv.classList.add('pirelly-custom-tooltip');
    imageDiv.setAttribute('src', '/add-icon.svg');
    hotSpotDiv.appendChild(imageDiv);
  };

  const hotspot2 = (hotSpotDiv) => {
    return;
    const imageDiv = document.createElement('img');
    imageDiv.setAttribute('id', 'test2');
    imageDiv.classList.add('push-start');
    imageDiv.setAttribute('src', '/pointer.svg');
    hotSpotDiv.appendChild(imageDiv);
  };

  const handleClickHotSpot = (evt, name, pitchValue, yawValue) => {
    // return;

    dispatch(carHotSpotEnableSet(false));
    dispatch(carHotSpotCardOpenToggled());
    dispatch(carHotSpotCardStatusSet(1));
    dispatch(pitchSet(pitchValue));
    dispatch(yawSet(yawValue));
  };

  useEffect(() => {
    const handleHotspot = () => {
      if (carHotSpotEnable)
        document.querySelectorAll('.pnlm-hotspot-base').forEach(function (e) {
          e.style.display = 'flex';
        });
      else
        document.querySelectorAll('.pnlm-hotspot-base').forEach(function (e) {
          e.style.display = 'none';
        });
    };
    handleHotspot();
  }, [carHotSpotEnable, load]);

  const handleHeight = () => {
    if (width > height) return height;
    else return (width * 9) / 16;
  };

  const handleTop = () => {
    if (width < height) return `calc(50% - ${handleHeight() / 2}px);`;
    else return 0;
  };

  const handleChange = () => {
    dispatch(carHotSpotEnableSet(carHotSpotEnable ? false : true));
  };

  return (
    <Box
      height={handleHeight()}
      position={'absolute'}
      top={handleTop()}
      width={'100%'}
    >
      {isPortrait && <Buttons />}
      <Pannellum
        // onScenechange={(id) => {
        //   console.log("Scene has change on " + id);
        // }}
        // onScenechangefadedone={() => {
        //   console.log("panorama loaded");
        // }}
        // onError={(err) => {
        //   console.log("Error", err);
        // }}
        // onErrorcleared={() => {
        //   console.log("Error Cleared");
        // }}
        // onMouseup={(evt) => {
        //   console.log("Mouse Up", evt);
        // }}
        autoLoad
        autoRotate={0}
        compass={false}
        getConfig={(data) => {
          console.log(data);
        }}
        height="100%"
        hotspotDebug={false}
        image={interiorImage}
        mouseZoom={true}
        onLoad={() => {
          console.log('panorama loaded');
          setLoad(true);
        }}
        onMousedown={(evt) => {
          console.log('Mouse Down', evt);
        }}
        orientationOnByDefault={true}
        pitch={-10}
        showFullscreenCtrl={false}
        showZoomCtrl={!isMobile}
        tip={10}
        width="100%"
        yaw={175}
      >
        {[
          { handleClickArg: 'test1', pitch: -30, tooltip: hotspot, yaw: 140 },
          { handleClickArg: 'test2', pitch: -30, tooltip: hotspot1, yaw: 200 },
          {
            handleClickArg: 'test3',
            pitch: -11,
            tooltip: hotspot2,
            type: 'video',
            yaw: -60,
          },
        ].map((item, id) => (
          <Pannellum.Hotspot
            createTooltipArgs="Baltimore Museum of Art"
            cssClass="custom-hotspot"
            handleClick={(evt, name) => {
              if (name === 'test1') {
                dispatch(showVideoToggled());
                dispatch(activeVideoSet('push-start'));
              }
              return;
              if (item?.type === 'video') dispatch(showVideoToggled());
              else handleClickHotSpot(evt, name, item.pitch, item.yaw);
            }}
            handleClickArg={item.handleClickArg}
            key={id}
            pitch={item.pitch}
            tooltip={item.tooltip}
            type="custom"
            yaw={item.yaw}
          />
        ))}
      </Pannellum>

      <Box
        sx={{
          [theme.breakpoints.down('lg')]: {
            transform: isPortrait ? 'translate(0.5rem , 0.6rem)' : 'none',
          },
        }}
      >
        <HotspotButton checked={carHotSpotEnable} onChange={handleChange} />
      </Box>
    </Box>
  );
}

export default Interior360;
